import { Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "./components/Shell";
import { HomePage } from "./pages/HomePage";
import { MarketPage } from "./pages/MarketPage";
import { ProductPage } from "./pages/ProductPage";
import { LibraryPage } from "./pages/LibraryPage";
import { InsightsPage } from "./pages/InsightsPage";
import { AIPage } from "./pages/AIPage";
import { ProfilePage } from "./pages/ProfilePage";
import { CartPage } from "./pages/CartPage";
import { DiscussionPage } from "./pages/DiscussionPage";
import { AcademyPage } from "./pages/AcademyPage";
import { AcademyCoursePage } from "./pages/AcademyCoursePage";
import { MyLearningPage } from "./pages/MyLearningPage";
import { CertificatePage } from "./pages/CertificatePage";
import { ServicesPage } from "./pages/ServicesPage";
import { ServicePage } from "./pages/ServicePage";
import { MyBookingsPage } from "./pages/MyBookingsPage";
import { InboxPage } from "./pages/InboxPage";
import { ServicePavilionFrame } from "./world/ServicePavilionFrame";

export default function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/market" element={<MarketPage />} />
        <Route path="/market/:slug" element={<ProductPage />} />
        <Route path="/discussion/:id" element={<DiscussionPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/services" element={<ServicePavilionFrame><ServicesPage /></ServicePavilionFrame>} />
        <Route path="/services/:slug" element={<ServicePavilionFrame><ServicePage /></ServicePavilionFrame>} />
        <Route path="/bookings" element={<MyBookingsPage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/academy" element={<AcademyPage />} />
        <Route path="/academy/:slug" element={<AcademyCoursePage />} />
        <Route path="/learning" element={<MyLearningPage />} />
        <Route path="/certificate" element={<CertificatePage />} />
        <Route path="/certificate/:code" element={<CertificatePage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/ai" element={<AIPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
